// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__V7XcH","active":"styles_active__Ls4xS","panel":"styles_panel__x7oq5","visible":"styles_visible__tLdMe","icon":"styles_icon__fZrVH"};